export let Buffer = require("buffer").Buffer
export let process = require("process/browser")
export let __dirname = "/"
